import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Hardware from '../views/Hardware.vue'
import SetupTelkomNewDevice from '../views/SetupTelkomNewDevice.vue'
import SetupTelkomOldDevice from '../views/SetupTelkomOldDevice.vue'
import SetupPureNewDevice from '../views/SetupPureNewDevice.vue'
import SetupPureDeviceType from '../views/SetupPureDeviceType.vue'
import SetupPureHuawei from '../views/SetupPureHuawei.vue'
import SetupPureGeneric from '../views/SetupPureGeneric.vue'

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home
    },
    {
        path: '/hardware',
        name: 'hardware',
        component: Hardware
    },
    {
        path: '/setup/telkom-lte/new-device',
        name: 'setup-telkom-new-device',
        component: SetupTelkomNewDevice
    },
    {
        path: '/setup/telkom-lte/old-device',
        name: 'setup-telkom-old-device',
        component: SetupTelkomOldDevice
    },
    {
        path: '/setup/pure-lte/new-device',
        name: 'setup-pure-new-device',
        component: SetupPureNewDevice
    },
    {
        path: '/setup/pure-lte/device-type',
        name: 'setup-pure-device-type',
        component: SetupPureDeviceType
    },
    {
        path: '/setup/pure-lte/device/huawei',
        name: 'setup-pure-device-huawei',
        component: SetupPureHuawei
    },
    {
        path: '/setup/pure-lte/device/generic',
        name: 'setup-pure-device-generic',
        component: SetupPureGeneric
    }
];

const router = new VueRouter({
    routes
});

export default router
